var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.865 2a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM8.25 2a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm4.134 1.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: "#626E85"
  })));
}
export default __webpack_public_path__ + "static/union-icon.6acb6635.svg";
export { SvgUnionIcon as ReactComponent };